import { h } from "preact";

import style from './style';
import { Text } from "preact-i18n";

const SubHeading = ({ text }) => <h3 class={style["subheading"]}><Text id={`headings.${text}`}>{text}</Text></h3>;

export default SubHeading;
